/**
 * Ошибки файлов заметок: нет ключа пользователя, нет права писать в заметку, файла нет на этом
 * узле, файл или кусок больше предела, сеть, недоступен storage, нет способа записать на диск
 */
export enum EnumNoteFileError {
  NO_USER_KEY = 'no_user_key',
  FORBIDDEN = 'forbidden',
  NOT_ON_NODE = 'not_on_node',
  TOO_LARGE = 'too_large',
  NETWORK = 'network',
  STORAGE_UNAVAILABLE = 'storage_unavailable',
  SAVE_NOT_SUPPORTED = 'save_not_supported',
}
